import * as React from 'react';

// The opening's book section, drawn from props only, right under the stage
// header: the opening's variation (the header's title is its family) and,
// once the game left the book, a jump to the last book position. No ECO code
// (it is the header title's tooltip) and no "left the book at" text. The moves
// the book knows from the board's position are shown by the best-moves panel,
// not here. `index.tsx` reads the book and the review and passes the result;
// stories pass it by hand.

export type BookStatus = 'idle' | 'loading' | 'ready' | 'unavailable';

export interface BookSectionProps {
  status: BookStatus;
  /** The game's deepest named opening; absent when it never reached one. */
  opening?: { eco: string; name: string };
  /** "Still in the book" or "Left the book at 10. h3". */
  statusText?: string;
  /** The last position in the book, when the game left it; drives "Go there". */
  leftAtPly?: number;
  onGo: (ply: number) => void;
}

export const BookSection: React.FC<BookSectionProps> = ({ status, opening, statusText, leftAtPly, onGo }) => {
  // Only a named opening is content; loading, an unreadable book and a game
  // with no named position show nothing rather than an empty-state line.
  // The stage header's title is the opening's family ("Ruy Lopez"); this line
  // carries the variation after the colon ("Closed, Breyer Defense"), then the
  // jump once the game left the book. Nothing when it has neither.
  if (status !== 'ready' || !opening) return null;
  const at = opening.name.indexOf(': ');
  const variation = at < 0 ? undefined : opening.name.slice(at + 2);
  if (!variation && leftAtPly === undefined) return null;
  const line = (
      <>
        {variation && (
          <span className="opening-name" title={opening.name}>
            {variation}
          </span>
        )}
        {leftAtPly !== undefined && (
          <button type="button" className="btn btn-ghost opening-jump" onClick={() => onGo(leftAtPly)} title="Go to the last position in the book">
            Go there
          </button>
        )}
      </>
    );
  return <div className="review-opening opening-line">{line}</div>;
};
